// extracted by mini-css-extract-plugin
export var disabled = "_sb-0";